import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1902016c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  key: 0,
  style: {"height":"300px"},
  class: "d-flex align-items-center justify-content-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-center" }

import { onMounted, ref, computed } from "vue";
import UserService from "../../users/services/UserService";
import { Delete, Search, InfoFilled } from "@element-plus/icons-vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { ElNotification } from "element-plus";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupManageIndex',
  setup(__props) {

const t = i18n.global.t;
const isLoading = ref(true);
const tab = ref(10);
const data = ref<any>([]);
const searchTerm = ref("");
const newGroup = ref("");
const isSubmitting = ref(false);

const tempAddedGroup = ref<any>([]);

const deleteGroup = async (group: any) => {
  isSubmitting.value = true;
  try {
    await UserService.deleteGroupById(tab.value, {
      group: group,
    });
    ElNotification({
      title: t("status.success"),
      message: t("tip.updateSuccess"),
      type: "success",
    });
    data.value = data.value.filter((item: any) => item !== group);
  } catch (e) {
    console.error(e);
    ElNotification({
      title: t("status.failed"),
      message: t("tip.updateFailed"),
      type: "error",
    });
  }
  isSubmitting.value = false;
};

const addGroup = async () => {
  if (newGroup.value.trim() === "") return;
  isSubmitting.value = true;
  try {
    await UserService.addGroupById(tab.value, {
      group: newGroup.value,
    });
    ElNotification({
      title: t("status.success"),
      message: t("tip.updateSuccess"),
      type: "success",
    });
    data.value.unshift(newGroup.value);
    tempAddedGroup.value.push(newGroup.value);
  } catch (e) {
    console.error(e);
    ElNotification({
      title: t("status.failed"),
      message: t("tip.updateFailed"),
      type: "error",
    });
  }
  isSubmitting.value = false;
};

const filteredData = computed(() => {
  return data.value.filter(
    (item: any) =>
      !searchTerm.value ||
      item.toLowerCase().includes(searchTerm.value.toLowerCase())
  );
});

const changeTab = async () => {
  await fetchData();
  tempAddedGroup.value = [];
  newGroup.value = "";
  searchTerm.value = "";
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    const results = await UserService.getServiceById(tab.value);
    data.value = results;

    data.value = data.value.sort((a: any, b: any) => a.localeCompare(b));
  } catch (e) {
    console.error(e);
  }
  isLoading.value = false;
};

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_tabs, {
      modelValue: tab.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
      onTabChange: _cache[1] || (_cache[1] = ($event: any) => (changeTab())),
      class: "demo-tabs"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "MT4 Real",
          name: 10,
          disabled: isSubmitting.value || isLoading.value
        }, null, 8, ["disabled"]),
        _createVNode(_component_el_tab_pane, {
          label: "MT5 Real",
          name: 30,
          disabled: isSubmitting.value || isLoading.value
        }, null, 8, ["disabled"]),
        _createVNode(_component_el_tab_pane, {
          label: "MT4 Demo",
          name: 11,
          disabled: isSubmitting.value || isLoading.value
        }, null, 8, ["disabled"]),
        _createVNode(_component_el_tab_pane, {
          label: "MT5 Demo",
          name: 31,
          disabled: isSubmitting.value || isLoading.value
        }, null, 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { colspan: "24" }, {
                    default: _withCtx(() => [
                      _createVNode(ScaleLoader, { color: '#ffc730' })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_el_row, { class: "mb-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: searchTerm.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchTerm).value = $event)),
                            placeholder: _ctx.$t('tip.searchKeyWords'),
                            "prefix-icon": "el-icon-search",
                            clearable: "",
                            onClear: _cache[3] || (_cache[3] = ($event: any) => (searchTerm.value = '')),
                            "suffix-icon": _unref(Search),
                            disabled: isSubmitting.value,
                            onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (searchTerm.value = ''), ["escape"]))
                          }, null, 8, ["modelValue", "placeholder", "suffix-icon", "disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: newGroup.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newGroup).value = $event)),
                        placeholder: _ctx.$t('fields.addGroup'),
                        "prefix-icon": "el-icon-search",
                        clearable: "",
                        onClear: _cache[6] || (_cache[6] = ($event: any) => (newGroup.value = '')),
                        disabled: isSubmitting.value,
                        onKeyup: [
                          _withKeys(addGroup, ["enter"]),
                          _cache[7] || (_cache[7] = _withKeys(($event: any) => (newGroup.value = ''), ["escape"]))
                        ]
                      }, null, 8, ["modelValue", "placeholder", "disabled", "onKeyup"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "success",
                        class: "ms-3",
                        plain: "",
                        onClick: addGroup,
                        disabled: isSubmitting.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("action.add")), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredData.value, (group) => {
                    return (_openBlock(), _createBlock(_component_el_col, {
                      span: 4,
                      key: group,
                      class: _normalizeClass(['group', { 'bg-success': tempAddedGroup.value.includes(group) }])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", null, _toDisplayString(group), 1),
                          _createElementVNode("div", null, [
                            _createVNode(_component_el_popconfirm, {
                              "confirm-button-text": _ctx.$t('action.yes'),
                              "cancel-button-text": _ctx.$t('action.no'),
                              icon: _unref(InfoFilled),
                              "icon-color": "#ff4949",
                              title: _ctx.$t('tip.confirmPrompt'),
                              onConfirm: ($event: any) => (deleteGroup(group)),
                              width: "220"
                            }, {
                              reference: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "danger",
                                  plain: "",
                                  size: "small",
                                  icon: _unref(Delete),
                                  circle: "",
                                  disabled: isSubmitting.value
                                }, null, 8, ["icon", "disabled"])
                              ]),
                              _: 2
                            }, 1032, ["confirm-button-text", "cancel-button-text", "icon", "title", "onConfirm"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["class"]))
                  }), 128))
                ]),
                _: 1
              })
            ]))
      ])
    ])
  ], 64))
}
}

})